export default defineNuxtPlugin((nuxtApp) => {
    if (process.client) {
      const isLocalhost = window.location.hostname === 'localhost';
      const API_BASE_URL = isLocalhost ? 'http://localhost:5001/address' : 'https://gateway.cloudrestfulapi.com/address';
      const API_KEY = 'DU1eYMDG7j8yb199YDPg3'; // ใส่ API Key ของคุณที่นี่
  
      const fetchProvinces = async () => {
        try {
          const response = await $fetch(`${API_BASE_URL}/provinces?key=${API_KEY}`);
          if (!response.success) {
            throw new Error(response.error || 'Request failed');
          }
          return response.data;
        } catch (error) {
          console.error(error);
          return null;
        }
      };
  
      const fetchAmphures = async (provinceId) => {
        try {
          const response = await $fetch(`${API_BASE_URL}/amphure/${provinceId}?key=${API_KEY}`);
          if (!response.success) {
            throw new Error(response.error || 'Request failed');
          }
          return response.data;
        } catch (error) {
          console.error(error);
          return null;
        }
      };
  
      const fetchTambons = async (districtId) => {
        try {
          const response = await $fetch(`${API_BASE_URL}/tambon/${districtId}?key=${API_KEY}`);
          if (!response.success) {
            throw new Error(response.error || 'Request failed');
          }
          return response.data;
        } catch (error) {
          console.error(error);
          return null;
        }
      };
  
      // Add the fetchProvinces, fetchAmphures, and fetchTambons functions to the Nuxt app context
      nuxtApp.provide('address', {
        fetchProvinces,
        fetchAmphures,
        fetchTambons
      });
    }
  });